import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "index-header py-6 px-6 d-flex" }
const _hoisted_2 = { class: "text-white mt-1" }

import {user} from "@/api";
import {onMounted, ref} from "vue";
import store from "@/store";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderBox',
  setup(__props) {

const router = useRouter()

const info = ref<ReturnType<typeof user.GetUserInfo> | null>(null)

onMounted(() => {
  info.value = user.GetUserInfo()
  if (!info.value) {
    store.dispatch('snackBarModule/showError', '请先登录')
    router.push({ path: '/login' })
  }
})

function handleLogout() {
  window.localStorage.removeItem("user")
  store.dispatch('snackBarModule/showSuccess', '退出登录成功')
  router.push({ path: '/login' })
}

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title text-h6 font-weight-bold text-white" }, " 数字化智能教学互动平台 ", -1)),
    _createVNode(_component_v_menu, { "open-on-hover": "" }, {
      activator: _withCtx(({ props }) => [
        (info.value)
          ? (_openBlock(), _createElementBlock("div", _mergeProps({
              key: 0,
              class: "mr-10 d-flex setting"
            }, props), [
              _createVNode(_component_v_avatar, {
                size: "30",
                class: "mr-3",
                image: info.value.avatar
              }, null, 8, ["image"]),
              _createElementVNode("div", _hoisted_2, _toDisplayString(info.value.nickname), 1),
              _createVNode(_component_v_icon, {
                class: "mt-1",
                icon: "mdi-chevron-down",
                color: "white"
              })
            ], 16))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list, {
          density: "compact",
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              link: "",
              title: "用户设置"
            }),
            _createVNode(_component_v_list_item, {
              link: "",
              title: "退出登录",
              onClick: handleLogout
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})